import classes from "./index.module.css";
import { CheckboxCheckedInverted } from "@/components/Icons";

export const CheckedIcon = ({ className }: { className: string }) => (
  <div className={`${className} ${classes["checkbox-icon"]}`}>
    <CheckboxCheckedInverted fontSize={32} />
  </div>
);

export default CheckedIcon;
